import template from './bot-manager.html';
import controller from './bot-manager.controller';
import './bot-manager.styl';

let botManagerComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default botManagerComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/bot-manager/bot-manager.component.js
 **/